import { useEffect, useRef } from 'react';

export default function useBootScreen() {

  // ========================
  // PRINT CONTROL REFERENCE
  // ========================
  const printed = useRef(false);

  useEffect(() => {

    // ========================
    // PREVENT MULTIPLE EXECUTIONS
    // ========================
    if (printed.current) return;
    printed.current = true;

    // ========================
    // ASCII BOOT SCREEN CONTENT
    // ========================
    const ascii = `
      ██╗  ██╗██████╗ ██╗███████╗ ██████╗ █████╗ ██████╗ ████████╗███████╗██╗
      ██║ ██╔╝██╔══██╗██║██╔════╝██╔════╝██╔══██╗██╔══██╗╚══██╔══╝██╔════╝██║
      █████╔╝ ██████╔╝██║███████╗██║     ███████║██████╔╝   ██║   █████╗  ██║
      ██╔═██╗ ██╔══██╗██║╚════██║██║     ██╔══██║██╔══██╗   ██║   ██╔══╝  ██║
      ██║  ██╗██║  ██║██║███████║╚██████╗██║  ██║██║  ██║   ██║   ███████╗███████╗

      ██╗  ██╗ ██████╗ ██╗   ██╗███████╗███████╗
      ██║  ██║██╔═══██╗██║   ██║██╔════╝██╔════╝
      ███████║██║   ██║██║   ██║███████╗█████╗
      ██╔══██║██║   ██║██║   ██║╚════██║██╔══╝
      ██║  ██║╚██████╔╝╚██████╔╝███████║███████╗

      🏰 © ${new Date().getFullYear()} | All Rights Reserved.
      https://github.com/KABUYA-SINA
    `;

    // ========================
    // CONSOLE OUTPUT STYLING
    // ========================
    console.log(
      `%c${ascii}`,
      'color: #00ff00; font-family: monospace;'
    );

  }, []);
}